import { isPlatform } from '@ionic/react';

export type DeviceType = 'iOS' | 'Android' | 'Web';

export const getDeviceType = (): DeviceType => {
  if (isPlatform('hybrid')) {
    if (isPlatform('ios')) {
      return 'iOS';
    }
    if (isPlatform('android')) {
      return 'Android';
    }
  }
  return 'Web';
};
